import React, { Fragment, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { memberMenu } from "../../services/member";
import ImageUrl from "../../ImageUrl";

// Sidebar for member logins (role 4). Like the staff sidebars, the menu comes
// from role_menu_access, so it is managed from the Role Permissions screen. The
// staff menu endpoints are behind staff.only, so this reads member/menu, which
// resolves the role from the token.

// Same sidebar header logo as the Super Admin (role 1) sidebar: the MSR Crest
// Capital deployment uses its own logo, every other deployment the default.
const isMsrDeployment = ImageUrl.includes("msrcrestcapital");
const desktopLogo = isMsrDeployment
  ? require("../../assets/images/logo/sidebar.png")
  : require("../../assets/images/logo/service_amylogo.png");

const MemberSideBar = () => {
  const [menuitems, setMenuitems] = useState([]);

  function errorhandle(ev) {
    ev.target.src = require("../../assets/images/logo/service_amylogo.png");
    ev.target.onerror = null;
  }

  useEffect(() => {
    memberMenu().then((res) => {
      if (res?.status === true && res.data?.Items) {
        setMenuitems(res.data.Items);
      }
    });
  }, []);

  return (
    <Fragment>
      <div className="sticky" style={{ marginBottom: "-64px" }}>
        <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
          <div className="main-container-1 active main-sidebar-header">
            <Scrollbars
              options={{ removeTrackXWhenNotUsed: true }}
              className="hor-scroll"
              style={{ position: "absolute" }}
            >
              <div className="sidemenu-logo">
                <Link className="main-logo" to={"/member/dashboard"}>
                  <img
                    src={desktopLogo}
                    className="header-brand-img desktop-logo"
                    alt={"logo1"}
                    onError={errorhandle}
                  />

                  <img
                    src={require("../../assets/images/logo/amylogo.png")}
                    className="header-brand-img icon-logo"
                    alt={"logo-2"}
                  />

                  <img
                    src={desktopLogo}
                    className="header-brand-img desktop-logo theme-logo"
                    alt={"logo-3"}
                    onError={errorhandle}
                  />
                  <img
                    src={require("../../assets/images/logo/service_amylogo.png")}
                    className="header-brand-img icon-logo theme-logo"
                    alt={"logo-4"}
                  />
                </Link>
              </div>
              <div className="main-body-1 main-sidebar-body">
                <ul className="menu-nav nav" style={{ marginLeft: "0px" }}>
                  <li className="nav-header">
                    <span className="nav-label">My Account</span>
                  </li>
                  {menuitems.map((item) => (
                    <li className="nav-item" key={item.id}>
                      <NavLink className="nav-link" to={item.path || "#"}>
                        <i className={`${item.icon || "fa fa-circle-o"} sidemenu-icon`}></i>
                        <span className="sidemenu-label">{item.title}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MemberSideBar;
